import { Component, OnInit, Output, EventEmitter } from '@angular/core';

/**
 * Modal de error generico
 */
@Component({
  standalone: false,
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  /**
   * Mensaje del error
   */
  message: string;
  /**
   * Output para emitir cuando se cierra el modal
   */
  @Output() closeError = new EventEmitter<boolean>();

  /**
   * Crea una instancia para error component.
   */
  constructor() { }

  /**
   * on init
   */
  ngOnInit() {
    this.GetMessageError();
  }

  /**
   * Emite el evento de cerrar el modal
   */
  close() {
    this.closeError.emit(false);
  }

  /**
   * Setea el mensaje de error desde el storage
   */
  GetMessageError(){
    this.message = sessionStorage.getItem('e');
    sessionStorage.removeItem('e');
  }

}
